import {
    OPERATOR_APPLICATION_NEW_CROSS_OPERATOR_MESSAGE,
    OPERATOR_APPLICATION_SOUND_NEW_DIALOG,
    OPERATOR_APPLICATION_SOUND_NEW_MESSAGE
} from "~/operatorApplication/ts/service/OperatorApplicationSoundPlayer";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";

export default function playNotificationSoundAboutClientMessage(
    client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel,
    isNewDialog: boolean,
    notifySoundOnce: boolean,
    notificationSettings?: CometOperatorApplication.MessageOperatorNotificationConfigOpenApiModel
) {
    if (CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(client)) {
        OPERATOR_APPLICATION_NEW_CROSS_OPERATOR_MESSAGE.play(notifySoundOnce, notificationSettings);
    } else {
        if (isNewDialog) {
            OPERATOR_APPLICATION_SOUND_NEW_MESSAGE.stop();
            OPERATOR_APPLICATION_SOUND_NEW_DIALOG.play(notifySoundOnce, notificationSettings);
        } else {
            OPERATOR_APPLICATION_SOUND_NEW_MESSAGE.play(notifySoundOnce, notificationSettings);
        }
    }
}